module.exports = __webpack_public_path__ + "static/media/icon-menu.9a2cc8d6.svg";